// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"282":"5bdeedd8","787":"79a8f28d"}[chunkId] + ".chunk.js";
};